import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import * as actions from '../../../../redux/projects/actions.projects';
import FilterSwitcher from '../../../components/FilterSwitcher/FilterSwitcher';
import InlineEditor from '../../../components/InlineEditor/InlineEditor';
import ToasterService from '../../../../services/ToasterService';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { DEFAULT_LANGUAGE_ID, DEFAULT_REION_ID, DEFAULT_VOICE_NAME } from '../../../../const/defaultVoice';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import ReactTooltip from 'react-tooltip';
import { IProject } from '../../../../models/IProject';
import { ICohort } from '../../../../models/ICohort';
import { getBoolOption } from '../getProjectOptions';
import { getDefaultOptionsValue, KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL, QRCODE_ENABLED_OPT_KEY, QRCODE_ENABLED_OPT_LABEL, TEXT_CHAT_ENABLED_KEY, TIMEOUT_OPT_KEY, PAGE_STATE_AUTO_SYNC_ENABLED_KEY, WAKE_WORD_ENABLED_OPT_KEY, WAKE_WORD_IN_BACKGROUND_OPT_KEY, WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD, WAKE_WORD_IN_BACKGROUND_OPT_LABEL, WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY, WAKE_WORD_PATH_OPT_KEY } from '../defaultProjectOptions';
import { Environment } from '../../../../const/environment';
import { IWakeWord } from '../../../../models/IWakeWord';
import { getSelectedWakeWordIdByModelUrl } from '../../../../services/mini/getSelectedWakeWordIdByModelUrl';
import { toogleBooleanOption } from '../../../../services/mini/toogleBooleanOption';
import { AlanButtonThemes } from '../../../../models/AlanButtonThemes';

const defaultItem = { id: 'default', name: 'Default style' };


const POPUP_ENABLED_OPT_KEY = 'alanButtonPopup.popupEnabled';
const POPUP_ENABLED_OPT_KEY_OLD = 'popupEnabled';

const DEBUG_CHAT_ENABLED_OPT_KEY = 'alanButtonPopup.debugChatEnabled';
const DEBUG_CHAT_ENABLED_OPT_KEY_OLD = 'debugChatEnabled';

const KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY = 'alanButtonDragAndDrop.keepButtonPositionAfterDnD';
const KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY_OLD = 'keepButtonPositionAfterDnD';

const DND_ENABLED_OPT_KEY = 'alanButtonDragAndDrop.dragAndDropEnabled';



type AlanButtonOptionsProps = PropsFromRedux & {
    projectId: string
    project: IProject
    environment: Environment
    platform: string
    selectedCohortId: string
    optionsMode: boolean
    isProjectResetting: boolean
    openOptions: () => void
    openVoicesForm: () => void
    openWakeWordSettings: () => void
    openVisualStyleSettings: () => void
    openExtensionSettings: () => void
    openModesSettings: () => void
    cohorts: ICohort[]
};



type AlanButtonOptionsState = {
    hidden: boolean
    timeout: number
    keepMicrophoneInBackground: boolean
    hideS2TPanel: boolean
    screenshotEnabled: boolean
    recordAudioEnabled: boolean
    selectedBtnOptionId: string
    playReadyToListenSound: boolean
    [KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY]: boolean,
    [DND_ENABLED_OPT_KEY]: boolean,
    [TEXT_CHAT_ENABLED_KEY]: boolean,
    [QRCODE_ENABLED_OPT_KEY]: boolean,
    [PAGE_STATE_AUTO_SYNC_ENABLED_KEY]: boolean,
    savedBtnOptionsStyles: any[],//todo get rid of any


    //ui state
    editTimeout: boolean
}

class AlanButtonOptions extends React.Component<AlanButtonOptionsProps, AlanButtonOptionsState> {

    _isMounted: boolean;


    constructor(props) {
        super(props);

        this.state = {
            savedBtnOptionsStyles: null,
            editTimeout: false,
            ...this.fillInitialState(props)
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.fillSavedBtnOptionsStyles();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const curProps = this.props;

        if (curProps.environment !== nextProps.environment ||
            curProps.selectedCohortId !== nextProps.selectedCohortId ||
            curProps.project?.stageOptions !== nextProps.project?.stageOptions ||
            curProps.project?.prodOptions !== nextProps.project?.prodOptions ||
            curProps.project?.testingOptions !== nextProps.project?.testingOptions ||
            curProps.optionsMode !== nextProps.optionsMode) {
            this.setState(
                {
                    ...this.fillInitialState(nextProps),
                    savedBtnOptionsStyles: this.state.savedBtnOptionsStyles,
                    editTimeout: false,
                });
            this.fillSavedBtnOptionsStyles();
        }
    }

    fillSavedBtnOptionsStyles = () => {
        const { projectId } = this.props;

        this.props.getButtonOptions({ projectId })
            .then((options) => {
                if (this._isMounted) {
                    this.setState({ savedBtnOptionsStyles: this.getSavedBtnOptionsStyleList(options) });
                }
            });
    }

    fillInitialState(props) {
        return {
            hidden: getBoolOption(props, 'hidden'),
            keepMicrophoneInBackground: getBoolOption(props, 'keepMicrophoneInBackground'),
            timeout: this.getTimeoutOption(props),
            hideS2TPanel: getBoolOption(props, 'hideS2TPanel'),
            screenshotEnabled: getBoolOption(props, 'screenshotEnabled'),
            recordAudioEnabled: getBoolOption(props, 'recordAudioEnabled'),
            selectedBtnOptionId: getBoolOption(props, 'selectedBtnOptionId'),
            playReadyToListenSound: getBoolOption(props, 'playReadyToListenSound'),
            [KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY]: getBoolOption(props, KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY, KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY_OLD),
            [POPUP_ENABLED_OPT_KEY]: getBoolOption(props, POPUP_ENABLED_OPT_KEY, POPUP_ENABLED_OPT_KEY_OLD),
            [DEBUG_CHAT_ENABLED_OPT_KEY]: getBoolOption(props, DEBUG_CHAT_ENABLED_OPT_KEY, DEBUG_CHAT_ENABLED_OPT_KEY_OLD),
            [DND_ENABLED_OPT_KEY]: getBoolOption(props, DND_ENABLED_OPT_KEY),
            [TEXT_CHAT_ENABLED_KEY]: getBoolOption(props, TEXT_CHAT_ENABLED_KEY),
            [QRCODE_ENABLED_OPT_KEY]: getBoolOption(props, QRCODE_ENABLED_OPT_KEY),
            [PAGE_STATE_AUTO_SYNC_ENABLED_KEY]: getBoolOption(props, PAGE_STATE_AUTO_SYNC_ENABLED_KEY),
        };
    }

    getSavedBtnOptionsStyleList(options) {
        return [
            ...[defaultItem],
            ...options
        ];
    }

    validateTimeout = (timeout) => {
        if (!(+timeout >= 0 && +timeout <= 600)) {
            return {
                error: 'Timeout should be in a range from 1 to 600'
            };
        }

        return {};
    }

    validateTimeoutBeforeChange = (timeout) => {
        const re = /^[0-9\.\b]+$/;
        if (timeout === '' || re.test(timeout)) {
            return true;
        }
        return false;
    }

    enterTimeoutEditMode = () => {
        this.setState({ editTimeout: true });
    }

    cancelTimeoutEditMode = () => {
        this.setState({ editTimeout: false });
    }

    onSaveTimeout = (timeout) => {
        this.setState({ timeout }, () => {
            this.setTimeoutOption();
        });
    }

    getTimeoutOption = (props) => {
        const { project, platform, environment, cohorts, selectedCohortId } = props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        if (project) {
            if (options[platform] && !_.isUndefined(options[platform].timeout)) {
                return options[platform].timeout / 1000;
            }
        }

        return getDefaultOptionsValue(platform, TIMEOUT_OPT_KEY);
    }

    setTimeoutOption = () => {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            setProjectOptions
        } = this.props;
        let { timeout } = this.state;

        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

        timeout = +timeout * 1000;

        options[platform].timeout = timeout;

        setProjectOptions({ project, options, environment, cohorts, selectedCohortId });
    }

    toggleBoolOption = (optionName, optionNameOld?) => {
        return toogleBooleanOption(this.props, this.state[optionName], (newVal) => {
            this.setState({ [optionName]: newVal } as AlanButtonOptionsState);
        }, false, optionName, optionNameOld);
    }

    saveProjectOptions(newOptions) {
        const {
            project,
            platform,
            environment,
            cohorts,
            selectedCohortId,
            setProjectOptions
        } = this.props;
        const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);
        const keys = Object.keys(newOptions);

        for (let i = 0; i < keys.length; i++) {
            const optionName = keys[i];
            options[platform] = _.set(options[platform], optionName, newOptions[optionName]);
        }
        this.setState(newOptions);
        setProjectOptions({ project, options, environment, cohorts, selectedCohortId });
    }

    setBtnEnableSettings = () => {
        this.toggleBoolOption('hidden');
    }

    setSpeech2TextSettings = () => {
        this.toggleBoolOption('hideS2TPanel');
    }

    setScreenshotEnabledSettings = () => {
        this.toggleBoolOption('screenshotEnabled');
    }

    setRecordAudioSettings = () => {
        this.toggleBoolOption('recordAudioEnabled');
    }

    setPlayReadyToListenSoundSettings = () => {
        this.toggleBoolOption('playReadyToListenSound');
    }

    setKeepButtonPositionAfterDnDSettings = () => {
        this.toggleBoolOption(KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY, KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY_OLD);
    }

    setPageStateAutoSync = () => {
        this.toggleBoolOption(PAGE_STATE_AUTO_SYNC_ENABLED_KEY);
    }

    setDndEnabledSettings = () => {
        this.toggleBoolOption(DND_ENABLED_OPT_KEY);
    }

    setQrCodeEnabledSettings = () => {
        this.toggleBoolOption(QRCODE_ENABLED_OPT_KEY);
    }

    setPopupEnabledSettings = () => {
        const { platform } = this.props;
        if (platform === 'web') {
            this.toggleBoolOption(POPUP_ENABLED_OPT_KEY, POPUP_ENABLED_OPT_KEY_OLD);
        } else {
            // Disabling Alan Popup should disable Debug chat for ios and android.
            const newPopupEnabled = !this.state[POPUP_ENABLED_OPT_KEY];

            if (newPopupEnabled === false) {
                this.saveProjectOptions({
                    [DEBUG_CHAT_ENABLED_OPT_KEY]: false,
                    [POPUP_ENABLED_OPT_KEY]: false,
                    [DEBUG_CHAT_ENABLED_OPT_KEY_OLD]: false,
                    [POPUP_ENABLED_OPT_KEY_OLD]: false,
                });
            } else {
                this.saveProjectOptions({
                    [POPUP_ENABLED_OPT_KEY]: newPopupEnabled,
                    [POPUP_ENABLED_OPT_KEY_OLD]: newPopupEnabled,
                });
            }
        }
    }

    setDebugChatEnabledSettings = () => {
        // Enabling Debug chat should also enable Alan Popup
        const newDebugChatEnabled = !this.state[DEBUG_CHAT_ENABLED_OPT_KEY];

        if (newDebugChatEnabled) {
            this.saveProjectOptions({
                [DEBUG_CHAT_ENABLED_OPT_KEY]: true,
                [POPUP_ENABLED_OPT_KEY]: true,
                [DEBUG_CHAT_ENABLED_OPT_KEY_OLD]: true,
                [POPUP_ENABLED_OPT_KEY_OLD]: true,
            });
        } else {
            this.saveProjectOptions({
                [DEBUG_CHAT_ENABLED_OPT_KEY]: newDebugChatEnabled,
                [DEBUG_CHAT_ENABLED_OPT_KEY_OLD]: newDebugChatEnabled
            });
        }
    }

    setMicInBackgroundSettings = () => {
        const keepMicrophoneInBackground = this.state.keepMicrophoneInBackground;
        if (keepMicrophoneInBackground) {
            this.saveProjectOptions({
                keepMicrophoneInBackground: false,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY]: false,
                [WAKE_WORD_IN_BACKGROUND_OPT_KEY_OLD]: false,
            });
            ToasterService.showInfo({ title: 'With this option turned off, the <span class="highlighted-item-in-toast">' + WAKE_WORD_IN_BACKGROUND_OPT_LABEL + '</span> option is disabled.' });
        } else {
            this.toggleBoolOption('keepMicrophoneInBackground');
        }
    }

    render() {
        const {
            isProjectResetting,
            openVoicesForm,
            openWakeWordSettings,
            openVisualStyleSettings,
            openExtensionSettings,
            openModesSettings,
            platform,
            environment,
            project,
            cohorts,
            selectedCohortId,
            wakeWords
        } = this.props;
        const {
            hidden,
            timeout,
            keepMicrophoneInBackground,
            hideS2TPanel,
            screenshotEnabled,
            recordAudioEnabled,
            savedBtnOptionsStyles,
            selectedBtnOptionId,
            playReadyToListenSound,
            editTimeout
        } = this.state;

        const dragAndDropEnabled = this.state[DND_ENABLED_OPT_KEY];
        const keepButtonPositionAfterDnD = this.state[KEEP_BUTTON_POSITION_AFTER_DND_OPT_KEY];
        const popupEnabled = this.state[POPUP_ENABLED_OPT_KEY];
        const debugChatEnabled = this.state[DEBUG_CHAT_ENABLED_OPT_KEY];
        const wakeWordModelUrl = _.get(getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId)[platform], WAKE_WORD_MODEL_MODEL_URL_PATH_OPT_KEY);
        const selectedWakeWordId = wakeWords ? getSelectedWakeWordIdByModelUrl(wakeWords, wakeWordModelUrl) : null;

        let styleName;
        let lightStyleName, darkStyleName;

        if (savedBtnOptionsStyles) {
            if (savedBtnOptionsStyles.length === 0) {
                styleName = defaultItem.name;
            } else {
                const selectedStyle = _.find(savedBtnOptionsStyles, { id: selectedBtnOptionId });
                styleName = selectedStyle ? selectedStyle.name : defaultItem.name;

                const optionsPerPlatfrom = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId)[platform];

                if (optionsPerPlatfrom?.themes) {
                    lightStyleName = _.find(savedBtnOptionsStyles, { id: optionsPerPlatfrom?.themes[AlanButtonThemes.Light]?.id })?.name || '';
                    darkStyleName = _.find(savedBtnOptionsStyles, { id: optionsPerPlatfrom?.themes[AlanButtonThemes.Dark]?.id })?.name || '';
                }
            }
        }

        let currentWakeWord;
        let currentWakeWordName;
        if (selectedWakeWordId && wakeWords) {
            currentWakeWord = _.find(wakeWords, { id: selectedWakeWordId });
            if (currentWakeWord) {
                currentWakeWordName = currentWakeWord.name;
            }
        }

        let voicesLabel,
            voicesTooltip;

        const voices = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId)[platform].voices;
        const textChatEnabled = getBoolOption(this.props, TEXT_CHAT_ENABLED_KEY);

        if (!_.isEmpty(voices)) {
            const langKeys = Object.keys(voices);
            const langCount = langKeys.length;
            const firstLangId = langKeys[0];
            const firstRegId = Object.keys(voices[firstLangId])[0];
            let voiceName;

            if (_.isArray(voices[firstLangId][firstRegId])) {
                voiceName = voices[firstLangId][firstRegId][0].name;
            } else if (_.isObject(voices[firstLangId][firstRegId])) {
                voiceName = voices[firstLangId][firstRegId].name;
            }

            const voiceLabels = [];

            voicesLabel = `${firstLangId}-${firstRegId} (${voiceName})`;
            if (langCount > 1) {
                voicesLabel += ` +${langCount - 1} more`;
                langKeys.forEach(function (langId, i) {
                    if (i > 0) {
                        Object.keys(voices[langId]).forEach(function (regId) {
                            if (_.isArray(voices[langId][regId])) {
                                voices[langId][regId].forEach(nameInfo => {
                                    voiceLabels.push(`${langId}-${regId} (${nameInfo.name})`);
                                });
                            } else if (_.isObject(voices[langId][regId])) {
                                const nameInfo = voices[langId][regId];
                                voiceLabels.push(`${langId}-${regId} (${nameInfo.name})`);
                            }
                        });
                    }
                });
                voicesTooltip = voiceLabels.join(', ');
            }
        } else {
            voicesLabel = `${DEFAULT_LANGUAGE_ID}-${DEFAULT_REION_ID} (${DEFAULT_VOICE_NAME})`;
        }

        return <div className="alan-button-options">
            <div className="alan-button-options_table">
                <div className="alan-button-options_table_column">
                    <div className="alan-button-options_table_row">
                        <div className="alan-button-options_enable"
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip"
                            data-for="showAlanBtnSettings"
                            data-tip="Disables visibility of the Alan button in your website/application.">
                            <FilterSwitcher
                                labelIfTrue="Alan button is visible"
                                labelIfFalse="Alan button is visible"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setBtnEnableSettings}
                                value={!hidden} />
                            <ReactTooltip id="showAlanBtnSettings" />
                        </div>
                    </div>
                    <div className="alan-button-options_table_row">
                        <div className="alan-button-options_speech-2-text"
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="showSpeachToTextPanelSettings"
                            data-tip="Disables visibility of the speech to text in your website/application"
                        >
                            <FilterSwitcher
                                labelIfTrue="Show “Speech to text” panel"
                                labelIfFalse="Show “Speech to text” panel"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setSpeech2TextSettings}
                                value={!hideS2TPanel} />
                            <ReactTooltip id="showSpeachToTextPanelSettings" />
                        </div>
                    </div>
                    <div className="alan-button-options_table_row">
                        <div className={`alan-button-options_record-audio`}
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="recodIntentAudioSettings"
                            data-tip="Allows recording intent audio from the app">
                            <FilterSwitcher
                                labelIfTrue="Record intent audio"
                                labelIfFalse="Record intent audio"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setRecordAudioSettings}
                                value={recordAudioEnabled} />
                            <ReactTooltip id="recodIntentAudioSettings" />
                        </div>
                    </div>
                    <div className={`alan-button-options_table_row ${platform !== 'web' && 'hidden'}`}>
                        <div title="Disables ready-to-listen sound in your website/application" className={`${platform !== 'web' && 'disabled'}`}>
                            <FilterSwitcher
                                labelIfTrue="Play ready-to-listen sound"
                                labelIfFalse="Play ready-to-listen sound"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setPlayReadyToListenSoundSettings}
                                value={playReadyToListenSound} />
                        </div>
                    </div>
                    <div className={`alan-button-options_table_row ${platform !== 'web' && 'hidden'}`}>
                        <div title="Allows changing the button position in the app"
                            className={`${platform !== 'web' && 'disabled'}`}>
                            <FilterSwitcher
                                labelIfTrue="Allows changing the button position"
                                labelIfFalse="Allows changing the button position"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setDndEnabledSettings}
                                value={dragAndDropEnabled} />
                        </div>
                    </div>
                    <div className={`alan-button-options_table_row ${platform !== 'web' && 'hidden'}`}>
                        <div title="Allows keeping the latest position of the Alan button in the app"
                            className={`${platform !== 'web' && 'disabled'}`}>
                            <FilterSwitcher
                                labelIfTrue="Save the button position after drag-n-drop"
                                labelIfFalse="Save the button position after drag-n-drop"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setKeepButtonPositionAfterDnDSettings}
                                value={keepButtonPositionAfterDnD} />
                        </div>
                    </div>
                    {platform === 'web' &&
                        <div className="alan-button-options_table_row">
                            <div title="Allows sending the current page state automatically to the Alan Server">
                                <FilterSwitcher
                                    labelIfTrue="Send current page state to the server automatically"
                                    labelIfFalse="Send current page state to the server automatically"
                                    offMode={true}
                                    minWidth="100%"
                                    maxWidth="100%"
                                    labelOnLeftSide={true}
                                    onClick={this.setPageStateAutoSync}
                                    value={this.state[PAGE_STATE_AUTO_SYNC_ENABLED_KEY]} />
                            </div>
                        </div>}

                    {/* <div className="alan-button-options_table_row">
                        <div title="Allows displaying popups next to the Alan button in the website/application">
                            <FilterSwitcher
                                labelIfTrue="Enable Alan Button Popup"
                                labelIfFalse="Enable Alan Button Popup"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setPopupEnabledSettings}
                                value={popupEnabled} />
                        </div>
                    </div> */}
                    {/* {platform !== 'web' &&
                        <div className="alan-button-options_table_row">
                            <div title="Allows keeping the latest position of the Alan button in the app">
                                <FilterSwitcher
                                    labelIfTrue="Enable Debug Chat"
                                    labelIfFalse="Enable Debug Chat"
                                    offMode={true}
                                    minWidth="100%"
                                    maxWidth="100%"
                                    labelOnLeftSide={true}
                                    onClick={this.setDebugChatEnabledSettings}
                                    value={debugChatEnabled} />
                            </div>
                        </div>} */}
                    <div className="alan-button-options_table_row no-padding">
                        <div className="alan-button-options_change-styles">
                            <span className="alan-button-options_change-styles_label">
                                <span>Alan voice</span>
                                <span
                                    className="alan-button-options_change-styles_style-name"
                                    title={voicesTooltip}>
                                    {voicesLabel}</span>
                            </span>
                            <div
                                data-place="bottom"
                                data-multiline="true"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                data-for="alanButtonWakeWordSettings"
                                data-tip="Change the voice and pronunciation of Alan responses"
                                className={`action-btn light-blue-with-border alan-button-options_btn stage-prod-btn ${isProjectResetting && 'disabled'}`}
                                onClick={openVoicesForm}>
                                Configure
                            </div>
                            <ReactTooltip id="alanButtonWakeWordSettings" />
                        </div>
                        <ReactTooltip id="voicesIsNotAvailable" />
                    </div>
                    <div className="alan-button-options_table_row no-padding">
                        <div className={`alan-button-options_timeout ${editTimeout && 'in-edit-mode'}`}
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="alanButtonVoiceSettings"
                            data-tip="Sets the microphone deactivation time if there is no activity">
                            <span className="alan-button-options_timeout_label">Microphone timeout</span>
                            <ReactTooltip id="alanButtonTimeoutSettings" />
                            <div className="alan-button-options_timeout_input-wrapper">
                                <InlineEditor
                                    key={timeout}
                                    withBorder={true}
                                    value={timeout.toString()}
                                    readOnly={false}
                                    autoFocus={true}
                                    validate={this.validateTimeout}
                                    beforeChangeValidation={this.validateTimeoutBeforeChange}
                                    exitEditModeAfterConfirm={true}
                                    onEnterEditMode={this.enterTimeoutEditMode}
                                    onLeaveEditMode={this.cancelTimeoutEditMode}
                                    confirmAction={(newTimeout) => {
                                        this.onSaveTimeout(newTimeout);
                                    }} />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="alan-button-options_table_column-sep" />

                <div className="alan-button-options_table_column">
                    <div className={`alan-button-options_table_row ${platform === 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_screenshot-enabled ${platform === 'web' && 'disabled'}`}
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="screenshotEnabledSettings"
                            data-tip="Allows taking screenshots from devices">
                            <FilterSwitcher
                                labelIfTrue="Allows taking screenshots from devices"
                                labelIfFalse="Allows taking screenshots from devices"
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setScreenshotEnabledSettings}
                                value={screenshotEnabled} />
                            <ReactTooltip id="screenshotEnabledSettings" />
                        </div>
                    </div>
                    <div className={`alan-button-options_table_row ${platform === 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_keep-mic-active ${platform === 'web' && 'disabled'}`}
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="micInBackgroundSettings"
                            data-tip={KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL}>
                            <FilterSwitcher
                                labelIfTrue={KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL}
                                labelIfFalse={KEEP_MICROPHONE_IN_BACKGROUND_OPT_LABEL}
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setMicInBackgroundSettings}
                                value={keepMicrophoneInBackground} />
                            <ReactTooltip id="micInBackgroundSettings" />
                        </div>
                    </div>
                    <div className={`alan-button-options_table_row no-padding ${platform === 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_wake-word ${platform === 'web' && 'disabled'}`}>
                            <span className="alan-button-options_change-styles_label">
                                {selectedWakeWordId !== undefined ?
                                    <span className="alan-button-options_change-styles_label">
                                        Wake word:
                                        {currentWakeWordName && <span className="alan-button-options_change-styles_style-name visible-with-opacity">{currentWakeWordName}</span>}
                                    </span> :
                                    <span className="alan-button-options_change-styles_label">
                                        Wake word
                                    </span>}
                            </span>
                            <div
                                data-place="bottom"
                                data-multiline="true"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                data-for="alanButtonVoiceSettings"
                                data-tip="Changes the wake word settings"
                                className={`action-btn light-blue-with-border alan-button-options_btn stage-prod-btn ${isProjectResetting && 'disabled'}`}
                                onClick={openWakeWordSettings}>
                                Configure
                            </div>
                            <ReactTooltip id="alanButtonVoiceSettings" />
                        </div>
                        <ReactTooltip id="voicesIsNotAvailable" />
                    </div>
                    <div className={`alan-button-options_table_row ${platform === 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_keep-mic-active ${platform === 'web' && 'disabled'}`}
                            data-place="bottom"
                            data-multiline="true"
                            data-effect="solid"
                            data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                            data-for="qrCodeEnabledSettings"
                            data-tip={QRCODE_ENABLED_OPT_LABEL}>
                            <FilterSwitcher
                                labelIfTrue={QRCODE_ENABLED_OPT_LABEL}
                                labelIfFalse={QRCODE_ENABLED_OPT_LABEL}
                                offMode={true}
                                minWidth="100%"
                                maxWidth="100%"
                                labelOnLeftSide={true}
                                onClick={this.setQrCodeEnabledSettings}
                                value={this.state[QRCODE_ENABLED_OPT_KEY]} />
                            <ReactTooltip id="qrCodeEnabledSettings" />
                        </div>
                    </div>
                    <div className="alan-button-options_table_row no-padding">
                        <div className="alan-button-options_change-styles">
                            {savedBtnOptionsStyles !== undefined ?
                                <span className="alan-button-options_change-styles_label">
                                    <span
                                        data-place="bottom"
                                        data-multiline="true"
                                        data-effect="solid"
                                        data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                        data-for="alanButtonVisualStyleSettings"
                                        data-tip="Changes the button style to match your app UI">
                                        Visual styles
                                    </span>

                                    {styleName && (!darkStyleName && !lightStyleName) && <span title={styleName} className="alan-button-options_change-styles_style-name visible-with-opacity">{styleName}</span>}
                                </span> :
                                <span
                                    className="alan-button-options_change-styles_label"
                                    data-place="bottom"
                                    data-multiline="true"
                                    data-effect="solid"
                                    data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                    data-for="alanButtonVisualStyleSettings"
                                    data-tip="Changes the button style to match your app UI">
                                    Visual styles
                                </span>}
                            <div
                                data-place="bottom"
                                data-multiline="true"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                data-for="alanButtonVisualStyleSettings"
                                data-tip="Changes the button style to match your app UI"
                                className={`action-btn light-blue-with-border alan-button-options_btn stage-prod-btn ${isProjectResetting && 'disabled'}`}
                                onClick={openVisualStyleSettings}>
                                Configure
                            </div>
                            <ReactTooltip id="alanButtonVisualStyleSettings" />
                        </div>
                    </div>

                    <div className={`alan-button-options_table_row ${platform !== 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_wake-word ${platform !== 'web' && 'disabled'}`}>
                            <span className="alan-button-options_change-styles_label">
                                <span className="alan-button-options_change-styles_label">
                                    <div className="alan-button-options_themes">
                                        <div style={{ minWidth: '55px' }}>Themes</div>
                                        {(lightStyleName && darkStyleName) ? <div className="alan-button-options_theme-names">
                                            <div className='alan-button-options_theme-name'>
                                                <SunIconSvg /><span title={`Light theme: ${lightStyleName}`} className="alan-button-options_change-styles_style-name visible-with-opacity">{lightStyleName}</span>
                                            </div>
                                            <div className='alan-button-options_theme-name'>
                                                <MoonIconSvg /><span title={`Dark theme: ${darkStyleName}`} className="alan-button-options_change-styles_style-name visible-with-opacity">{darkStyleName}</span>
                                            </div>
                                        </div> : <></>}
                                    </div>
                                </span>
                            </span>
                            <div
                                data-place="bottom"
                                data-multiline="true"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                data-for="alanButtonExtensionSettings"
                                data-tip="Changes styles for light and dark theme for the Alan Button and Text Chat"
                                className={`action-btn light-blue-with-border alan-button-options_btn stage-prod-btn ${isProjectResetting && 'disabled'}`}
                                onClick={openModesSettings}>
                                Configure
                            </div>
                            <ReactTooltip id="alanButtonExtensionSettings" />
                        </div>
                        <ReactTooltip id="voicesIsNotAvailable" />
                    </div>

                    <div className={`alan-button-options_table_row ${platform !== 'web' && 'hidden'}`}>
                        <div className={`alan-button-options_wake-word ${platform !== 'web' && 'disabled'}`}>
                            <span className="alan-button-options_change-styles_label">
                                <span className="alan-button-options_change-styles_label">
                                    Browser plugin
                                </span>
                            </span>
                            <div
                                data-place="bottom"
                                data-multiline="true"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip tutor-light-tooltip-240"
                                data-for="alanButtonExtensionSettings"
                                data-tip="Changes the Alan Button extension settings"
                                className={`action-btn light-blue-with-border alan-button-options_btn stage-prod-btn ${isProjectResetting && 'disabled'}`}
                                onClick={openExtensionSettings}>
                                Configure
                            </div>
                            <ReactTooltip id="alanButtonExtensionSettings" />
                        </div>
                        <ReactTooltip id="voicesIsNotAvailable" />
                    </div>
                </div>
            </div>
        </div>;
    }
}

function MoonIconSvg() {
    return <svg width="16px" height="16px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <g id="Lager_94" data-name="Lager 94" transform="translate(0)">
            <path id="Path_70" data-name="Path 70" d="M12.516,4.509A12,12,0,0,0,22.3,19.881,12.317,12.317,0,0,0,24,20a11.984,11.984,0,0,0,3.49-.514,12.1,12.1,0,0,1-9.963,8.421A12.679,12.679,0,0,1,16,28,12,12,0,0,1,12.516,4.509M16,0a16.5,16.5,0,0,0-2.212.15A16,16,0,0,0,16,32a16.526,16.526,0,0,0,2.01-.123A16.04,16.04,0,0,0,31.85,18.212,16.516,16.516,0,0,0,32,15.944,1.957,1.957,0,0,0,30,14a2.046,2.046,0,0,0-1.23.413A7.942,7.942,0,0,1,24,16a8.35,8.35,0,0,1-1.15-.08,7.995,7.995,0,0,1-5.264-12.7A2.064,2.064,0,0,0,16.056,0Z" fill="#5b7491" />
        </g>
    </svg>
}

function SunIconSvg() {
    return <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" fill="#5b7491" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2C11.25 1.58579 11.5858 1.25 12 1.25ZM4.39861 4.39861C4.6915 4.10572 5.16638 4.10572 5.45927 4.39861L5.85211 4.79145C6.145 5.08434 6.145 5.55921 5.85211 5.85211C5.55921 6.145 5.08434 6.145 4.79145 5.85211L4.39861 5.45927C4.10572 5.16638 4.10572 4.6915 4.39861 4.39861ZM19.6011 4.39887C19.894 4.69176 19.894 5.16664 19.6011 5.45953L19.2083 5.85237C18.9154 6.14526 18.4405 6.14526 18.1476 5.85237C17.8547 5.55947 17.8547 5.0846 18.1476 4.79171L18.5405 4.39887C18.8334 4.10598 19.3082 4.10598 19.6011 4.39887ZM1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H3C3.41421 11.25 3.75 11.5858 3.75 12C3.75 12.4142 3.41421 12.75 3 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12ZM20.25 12C20.25 11.5858 20.5858 11.25 21 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12ZM18.1476 18.1476C18.4405 17.8547 18.9154 17.8547 19.2083 18.1476L19.6011 18.5405C19.894 18.8334 19.894 19.3082 19.6011 19.6011C19.3082 19.894 18.8334 19.894 18.5405 19.6011L18.1476 19.2083C17.8547 18.9154 17.8547 18.4405 18.1476 18.1476ZM5.85211 18.1479C6.145 18.4408 6.145 18.9157 5.85211 19.2086L5.45927 19.6014C5.16638 19.8943 4.6915 19.8943 4.39861 19.6014C4.10572 19.3085 4.10572 18.8336 4.39861 18.5407L4.79145 18.1479C5.08434 17.855 5.55921 17.855 5.85211 18.1479ZM12 20.25C12.4142 20.25 12.75 20.5858 12.75 21V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V21C11.25 20.5858 11.5858 20.25 12 20.25Z" fill="#5b7491" />
    </svg>
}

function mapStateToProps({ projectsInfo, user }) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
        capabilities: user.capabilities,
        wakeWords: projectsInfo.currentProject.wakeWords,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setProjectOptions: (param) => asyncDispatch(actions.setProjectOptions, dispatch, param),
        getButtonOptions: (param) => asyncDispatch(actions.getButtonOptions, dispatch, param),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AlanButtonOptions);
